import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthenticationService } from '@core/services/authentication.serivce';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule } from '@progress/kendo-angular-layout';
import { LabelModule } from '@progress/kendo-angular-label';
import { DialogModule } from '@progress/kendo-angular-dialog';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { BenchTemplatesRoutingModule } from './bench-templates-routing.module';
import { BenchTemplateListComponent } from './bench-template-list/bench-template-list.component';
import { BenchTemplateService } from './services/bench-template.service';
import { BenchTemplateComponent } from './bench-template/bench-template.component';
import { BenchTemplateReassignItemComponent } from './bench-template-reassign-item/bench-template-reassign-item.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { GridDetailComponent } from '../../shared/components/grid-detail/grid-detail.component';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { BenchTemplateAddItemComponent } from './bench-template-add-item/bench-template-add-item.component';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BenchTemplateRemoveItemsComponent } from './bench-template-remove-items/bench-template-remove-items.component';


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    LayoutModule,
    LabelModule,
    TextBoxModule,
    GridLayoutModule,
    GridModule,
    DialogModule,
    GridDetailComponent,
    SelectFieldComponent,
    ContextMenuModule,
    DetailComponent,
    SearchComponent,
    BenchTemplatesRoutingModule,
    LoaderModule,
    FaIconComponent
  ],
  declarations: [
    BenchTemplateListComponent,
    BenchTemplateComponent,
    BenchTemplateReassignItemComponent,
    BenchTemplateAddItemComponent,
    BenchTemplateRemoveItemsComponent
  ],
  providers: [AuthenticationService, BenchTemplateService]
})
export class BenchTemplatesModule { }
